<template>
  <div class="zk-tree" :class="{ 'zk-tree--highlight-current': highlightCurrent }">
    <zk-tree-node
      v-for="child in tree.root.childNodes"
      :node="child"
      :props="props"
      :expandedAll="expandedAll"
      :render-content="renderContent">
    </zk-tree-node>
  </div>
</template>

<script>
  import Tree from './model/tree'

  export default {
    name: 'zk-tree',

    props: {
      data: {
        type: Array
      },
      renderContent: Function,
      showCheckbox: {
        type: Boolean,
        default: false
      },
      expandedAll: {
        type: Boolean,
        default: false
      },
      props: {
        default() {
          return {
            children: 'children',
            label: 'label',
            icon: 'icon'
          }
        }
      },
      lazy: {
        type: Boolean,
        default: false
      },
      highlightCurrent: Boolean,
      load: {
        type: Function
      }
    },

    created() {
      this.$isTree = true

      this.tree = new Tree({
        data: this.data,
        lazy: this.lazy,
        props: this.props,
        load: this.load
      })
    },

    data() {
      return {
        tree: {},
        currentNode: null
      }
    },

    components: {
      ZkTreeNode: require('./tree-node.vue')
    },

    computed: {
      children: {
        set(value) {
          this.data = value
        },
        get() {
          return this.data
        }
      }
    },

    watch: {
      data(newVal) {
        this.tree.root.setData(newVal)
      }
    },

    methods: {
      getCheckedNodes(leafOnly) {
        return this.tree.getCheckedNodes(leafOnly)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// tree.vue?23187840